module.exports = __webpack_public_path__ + "img/img_avatar_female.0590da9a.png";